import { render, staticRenderFns } from "./processInspectionAdd.vue?vue&type=template&id=3c9ebc28"
import script from "./processInspectionAdd.vue?vue&type=script&lang=js"
export * from "./processInspectionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports